<!-- REVISION = 20220308211423 -->
<!-- https://stackoverflow.com/questions/49268659/javascript-get-100vh-in-pixels -->
<!-- https://stackoverflow.com/questions/4096863/how-to-get-and-set-the-current-web-page-scroll-position -->
<script>

	import { afterUpdate, onMount } from 'svelte';

    export let menu_active_item = undefined;

    let categories = [];

    // const API = 'https://api-dev.python3-live.workers.dev';
    const API = 'https://api.python3.live';

    onMount(async () => {
        const res = await fetch(`${API}/categories-list`);
        categories = await res.json();
        // console.dir(categories)
    });

    afterUpdate(() => {
        updateMenuScroll(menu_active_item);
    });

    function handleClick(e) {
        //  console.dir(e) //DEBUG
         e.preventDefault();
        menu_active_item = e.target.getAttribute('data-slug');
        // console.log(menu_active_item) //DEBUG
    }

    function updateMenuScroll(menu_active_item) {
        if (menu_active_item != undefined) {
            // elementMenuActiveItem = menuActiveItem();
            const menu = document.getElementById('menu');
            if (menuActiveItem() && needScroll(menuActiveItem(), menu)) {
                menu.scroll(0, menuActiveItem().offsetTop);
                // console.log(elementMenuActiveItem) //DEBUG
                // console.log(elementMenuActiveItem.offsetTop) //DEBUG
            }
        }
    }

    const menuActiveItem = () => document.querySelector('.list-group-item.list-group-item-action.active');

    function needScroll(element, menu) {
        let _1vh = Math.round(window.innerHeight / 100);
        function vhToPixels (vh) {
            return Math.round(window.innerHeight / (100 / vh));
        }
        return element.offsetTop - menu.scrollTop > vhToPixels(85); //TODO Optimize
    }

</script>


<nav id="menu">
    <div class="list-group">
        {#each categories as category}
        <a class="list-group-item list-group-item-action" class:active={menu_active_item==category.slug} href="/{category.slug}" data-slug={category.slug} on:click={handleClick}>{category.title}</a>
        {/each}
    </div>
</nav>


<style>
    #menu {
        position: relative;
        min-height: calc(100vh - 4rem - 8rem);
        overflow-y: scroll;
    }
</style>
